import axiosInstance from "@/services/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const instance = axiosInstance();
async function getAttachments(search_type, proposal_id) {
  if (!proposal_id || search_type === "upload" || search_type === "sbir")
    return null;
  const response = await instance.get(
    `/contract/get-attachments/${search_type}/${proposal_id}`
  );

  return response.data;
}

export function useGetAttachments(searchType, proposalId) {
  return useQuery({
    queryKey: ["attachments", searchType, proposalId],
    queryFn: () => getAttachments(searchType, proposalId),
  });
}
